// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bhr_a bhr_x bhr_j bhr_u bhr_bc bhr_ql bhr_vv"};